import { Component, OnInit, ViewChild } from '@angular/core';
import { AlertController, IonModal, LoadingController, ToastController } from '@ionic/angular';
import { NaploService } from '../naplo.service';
import { DataService } from '../../data.service';

// NAPLO – Tárhely: globális Ügyfélkapu+/Cégkapu fiókok (intézmény-szinten), az ügyfélhez rendelt
// fiók+postafiók kapcsolatok, és az ügyfélre szűrt tárhely-üzenetek.
@Component({
  selector: 'app-naplo-tarhely',
  templateUrl: './tarhely.component.html',
  styleUrls: ['../naplo-shared.scss'],
})
export class TarhelyComponent implements OnInit {
  @ViewChild('fiokModal') fiokModal: IonModal;
  @ViewChild('fiokokModal') fiokokModal: IonModal;
  @ViewChild('hozzarModal') hozzarModal: IonModal;
  @ViewChild('uzenetModal') uzenetModal: IonModal;
  uzenetReszlet: any = null;

  uzenetek: any[] = [];
  fiokok: any[] = [];            // globális fiókok (intézmény)
  hozzarendelesek: any[] = [];   // az aktív ügyfélhez rendelt fiók+postafiók
  szerk: any = null;             // fiók szerkesztése
  ujHozzar: any = null;          // hozzárendelés szerkesztése
  mailboxLista: any[] = [];      // a kiválasztott fiók postafiókjai
  mailboxLoading = false;
  szuro = '';
  tipusOpciok = [
    { value: 'ugyfelkapu', label: 'Ügyfélkapu+ (személyes tárhely)' },
    { value: 'cegkapu', label: 'Cégkapu (hivatali tárhely)' },
    { value: 'ertesitesi', label: 'Értesítési tárhely' },
  ];

  constructor(private naplo: NaploService, private toast: ToastController, private alert: AlertController, private loadingCtrl: LoadingController, private data: DataService) {}

  get aktiv() { return this.naplo.aktiv; }

  async ngOnInit() {
    await this.naplo.init();
    if (!this.aktiv.ugyfelId) return;
    await Promise.all([this.betoltUzenetek(), this.betoltFiokok(), this.betoltHozzar()]);
  }

  async betoltUzenetek() {
    try { this.uzenetek = await this.naplo.get('/tarhely/' + this.aktiv.ugyfelId).then((r: any) => r.uzenetek || []); }
    catch { this.hiba('Nem sikerült betölteni az üzeneteket.'); }
  }
  async betoltFiokok() {
    try { this.fiokok = await this.naplo.get('/ugyfelkapu/fiokok/' + this.aktiv.intezmeny); }
    catch { this.hiba('Nem sikerült betölteni a fiókokat.'); }
  }
  async betoltHozzar() {
    try { this.hozzarendelesek = await this.naplo.get('/ugyfelkapu/hozzarendelesek/' + this.aktiv.ugyfelId); }
    catch { this.hiba('Nem sikerült betölteni a hozzárendeléseket.'); }
  }

  get szurtUzenetek() {
    const s = this.szuro.trim().toLowerCase();
    if (!s) return this.uzenetek;
    return this.uzenetek.filter(u => (u.felado || '').toLowerCase().includes(s) || (u.targy || '').toLowerCase().includes(s) || (u.tipus || '').toLowerCase().includes(s));
  }
  tipusCimke(v: string) { return this.tipusOpciok.find(t => t.value === v)?.label || v || ''; }

  // ---- Globális fiókok ----
  fiokokNyit() { this.fiokokModal.present(); }
  ujFiok() { this.szerk = { intezmeny: this.aktiv.intezmeny, cimke: '', login: '', jelszo: '', totp_secret: '', aktiv: true }; this.fiokModal.present(); }
  szerkFiok(f: any) { this.szerk = { ...f, intezmeny: this.aktiv.intezmeny, jelszo: '', totp_secret: '' }; this.fiokModal.present(); }
  async mentFiok() {
    if (!this.szerk?.login?.trim()) return this.hiba('A login kötelező.');
    try {
      if (this.szerk.id) await this.naplo.put('/ugyfelkapu/fiok/' + this.szerk.id, this.szerk);
      else await this.naplo.post('/ugyfelkapu/fiok', this.szerk);
      await this.fiokModal.dismiss(); await this.betoltFiokok(); this.ok('Fiók mentve.');
    } catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült menteni.'); }
  }
  async torolFiok(f: any) {
    const a = await this.alert.create({
      header: 'Törlés', message: `Biztosan törli a fiókot (${f.cimke || f.login})? A hozzárendelései is törlődnek.`,
      buttons: [{ text: 'Mégse', role: 'cancel' }, {
        text: 'Törlés', role: 'destructive', handler: async () => {
          try { await this.naplo.del('/ugyfelkapu/fiok/' + f.id); await Promise.all([this.betoltFiokok(), this.betoltHozzar()]); this.ok('Törölve.'); }
          catch { this.hiba('Nem sikerült törölni.'); }
        }
      }],
    });
    a.present();
  }

  // ---- Hozzárendelés az aktív ügyfélhez ----
  hozzarNyit() {
    if (!this.fiokok.length) { this.hiba('Előbb vegyél fel egy fiókot a „Fiókok" gombnál.'); return this.fiokokNyit(); }
    this.ujHozzar = { fiok_id: this.fiokok[0]?.id || null, ugyfel_id: this.aktiv.ugyfelId, mailbox_nev: '', szuro: '', tipus: 'cegkapu', aktiv: true };
    this.mailboxLista = [];
    this.hozzarModal.present();
    if (this.ujHozzar.fiok_id) this.mailboxBetolt(false);
  }
  // A fiók által látott postafiókok lekérése (cache-ből, vagy frissítve a NAV-belépéssel).
  async mailboxBetolt(frissit: boolean) {
    if (!this.ujHozzar?.fiok_id) return;
    this.mailboxLoading = true;
    try {
      const r: any = await this.naplo.get('/ugyfelkapu/fiok/' + this.ujHozzar.fiok_id + '/mailboxok' + (frissit ? '?frissit=1' : ''));
      this.mailboxLista = r.mailboxok || [];
      if (frissit) this.ok('Postafiókok frissítve.');
    } catch (e: any) { if (frissit) this.hiba(e?.error?.error || 'Nem sikerült lekérni a postafiókokat.'); }
    finally { this.mailboxLoading = false; }
  }
  async mentHozzar() {
    if (!this.ujHozzar?.fiok_id) return this.hiba('Válassz fiókot.');
    this.ujHozzar.ugyfel_id = this.aktiv.ugyfelId;
    try { await this.naplo.post('/ugyfelkapu/hozzarendeles', this.ujHozzar); await this.hozzarModal.dismiss(); await this.betoltHozzar(); this.ok('Hozzárendelve.'); }
    catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült hozzárendelni.'); }
  }
  async torolHozzar(h: any) {
    try { await this.naplo.del('/ugyfelkapu/hozzarendeles/' + h.id); await this.betoltHozzar(); this.ok('Eltávolítva.'); }
    catch { this.hiba('Nem sikerült eltávolítani.'); }
  }

  // ---- Szinkronizáció ----
  async szinkron() {
    if (!this.hozzarendelesek.length) { this.hiba('Előbb rendelj hozzá egy fiókot ehhez az ügyfélhez.'); return this.hozzarNyit(); }
    const l = await this.loadingCtrl.create({ message: 'Belépés a tárhelyre és üzenetek letöltése… (akár 1–2 perc)' });
    l.present();
    try {
      const r: any = await this.naplo.post('/tarhely/szinkron/' + this.aktiv.ugyfelId, {});
      await Promise.all([this.betoltUzenetek(), this.betoltHozzar()]);
      this.ok(`Szinkronizálva. Új üzenet: ${r?.uj ?? 0}.` + (r?.hibak?.length ? ' Figyelmeztetés: ' + r.hibak.join('; ') : ''));
    } catch (e: any) { this.hiba(e?.error?.error || 'Szinkronizáció sikertelen.'); }
    finally { l.dismiss(); }
  }

  async allapotValt(u: any, allapot: string) {
    try { await this.naplo.put('/tarhely/uzenet/' + u.id, { allapot }); u.allapot = allapot; }
    catch { this.hiba('Nem sikerült módosítani.'); }
  }

  // Üzenet részleteinek megnyitása modalban + olvasottnak jelölés.
  megnyitUzenet(u: any) {
    this.uzenetReszlet = { ...u, metaObj: this.parseMeta(u.meta) };
    this.uzenetModal.present();
    if (u.allapot === 'uj') this.allapotValt(u, 'olvasott');
  }
  parseMeta(m: any) { try { return typeof m === 'string' ? JSON.parse(m) : (m || {}); } catch { return {}; } }
  metaSorok(): { kulcs: string; ertek: any }[] {
    const m = this.uzenetReszlet?.metaObj || {};
    const cimkek: any = {
      erkeztetesiSzam: 'Érkeztetési szám', feladoNev: 'Feladó', feladoRovidNev: 'Feladó (rövid)',
      cimzettNev: 'Címzett', cimzettRovidNev: 'Címzett (rövid)', dokumentumTipus: 'Dokumentum típus',
      dokumentumLeiras: 'Leírás', tarolasiHely: 'Tárolási hely', fajlMeret: 'Fájlméret (byte)',
      erkezesiDatum: 'Érkezés', olvasatlan: 'Olvasatlan',
    };
    return Object.keys(cimkek).filter(k => m[k] != null && m[k] !== '').map(k => ({
      kulcs: cimkek[k],
      ertek: k === 'erkezesiDatum' ? new Date(m[k]).toLocaleString('hu-HU') : m[k],
    }));
  }
  // Melléklet letöltése (új ablakban). A backend a NAV-belépéssel letölti és kiszolgálja.
  letoltMelleklet(u: any) { this.data.megnyitFajl('/api/naplo/tarhely/melleklet/' + u.id, u?.nev || 'Melléklet'); }

  private async ok(m: string) { (await this.toast.create({ message: m, duration: 2000, color: 'success' })).present(); }
  private async hiba(m: string) { (await this.toast.create({ message: m, duration: 3500, color: 'danger' })).present(); }
}
